import { render, staticRenderFns } from "./growupRecord.vue?vue&type=template&id=533190e2&scoped=true&"
import script from "./growupRecord.vue?vue&type=script&lang=js&"
export * from "./growupRecord.vue?vue&type=script&lang=js&"
import style0 from "./growupRecord.vue?vue&type=style&index=0&id=533190e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533190e2",
  null
  
)

export default component.exports